/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingSourceQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("BillingSourceQueryOperator");
    }

    getFixupPrototypeFunction() { return BillingSourceQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<BillingSourceQueryOperator>): BillingSourceQueryOperator {
        let obj = Object.assign(new BillingSourceQueryOperator(), model);
        BillingSourceQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingSourceQueryOperator>): BillingSourceQueryOperator {
        if (!model) return null;
        return BillingSourceQueryOperator.newInstance(<BillingSourceQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingSourceQueryOperator) {
        if (!obj) return;

        models.BillingSourceQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingSourceQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingSourceQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing sources / cost metrics to include
     */
    billing_sources: Array<string>;

}
